module.exports = __webpack_public_path__ + "img/section4Logo10.22a2a5ca.svg";